import defaultColor from "@/components/color";

export default {
    cptDataForm:{
        dataSource: 1, pollTime: 0,
        dataText: '[{"name": "周口","value": 55},{"name": "南阳","value": 120},{"name": "西峡","value": 78},{"name": "驻马店","value": 66}]',
    },
    attribute:{
        lineWidth: 10,radius:80,activeRadius:60,showOriginValue:false,
        color: defaultColor,
        fontColor: '#fff',
        cptTableData: [{ "name": "维度", "value": "", "namekey": "name" },{ "name": "指标", "value": "", "namekey": "value" }] 
    },
    interaction:{intType: 'none'}
}